import { State } from "features/History/HistoryDetail/fetchHistoryDetail";
import { TFunction } from "i18next";
import { Semantics } from "shared/components/drops/DropsBadge";
import { AffectedStop, Distribution } from "shared/types/historyDetail";
import {
  CombinedHistoryResponse,
  GlobalOperationalInformationOverviewResponse,
  InfrastructureOperationalInformationOverviewResponse,
  StationOperationalInformationOverviewResponse,
  TrainOperationalInformationOverviewResponse,
} from "shared/types/operationalInformation";

export function eventIsTrainEvent(
  event: CombinedHistoryResponse,
): event is TrainOperationalInformationOverviewResponse {
  return event.type.group === "TRAIN";
}

export function eventIsGlobalEvent(
  event: CombinedHistoryResponse,
): event is GlobalOperationalInformationOverviewResponse {
  return event.type.group === "GLOBAL";
}

export function eventIsInfrastructureEvent(
  event: CombinedHistoryResponse,
): event is InfrastructureOperationalInformationOverviewResponse {
  return event.type.group === "INFRASTRUCTURE";
}

export function eventIsStationEvent(
  event: CombinedHistoryResponse,
): event is StationOperationalInformationOverviewResponse {
  return event.type.group === "STATION";
}

export const getDropsDistributionText = (distributions: Distribution[]) => {
  if (distributions.length > 0) {
    return (
      distributions.find((distribution) => distribution.contextName === "DROPS")
        ?.text.message ?? distributions[0].text.message
    );
  }
  return "";
};

export const groupLabels = (
  translate: TFunction<"translation", undefined>,
) => ({
  TRAIN: translate("Tog"),
  STATION: translate("Stasjon"),
  INFRASTRUCTURE: translate("Infrastruktur"),
  GLOBAL: translate("Global"),
});

function nameOrId(affectedStop: AffectedStop) {
  return affectedStop.name ?? affectedStop.jbvId;
}

export const getSubTitleFromAffectedStops = (affectedStops: AffectedStop[]) => {
  if (!affectedStops || affectedStops.length === 0) return "-";
  const firstStop = nameOrId(affectedStops[0]);
  if (affectedStops.length === 1) return firstStop;
  const lastStop = nameOrId(affectedStops[affectedStops.length - 1]);
  return `${firstStop} - ${lastStop}`;
};

export type EventState = {
  label: string;
  semantics: Semantics;
};

export const stateMap = (
  translate: TFunction<"translation", undefined>,
): {
  [key in State]: EventState;
} => ({
  OPEN: {
    label: translate("Åpen"),
    semantics: "warning",
  },
  CLOSED: {
    label: translate("Friskmeldt"),
    semantics: "success",
  },
  REPLACED: {
    label: translate("Erstattet"),
    semantics: "info",
  },
  UNHANDLED: {
    label: translate("Må behandles"),
    semantics: "alarm",
  },
  DEPUBLISHED: {
    label: translate("Depublisert"),
    semantics: "neutral",
  },
});
